import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
    const sessionId = params.get("session_id");

    const process = async () => {
      if (!sessionId) {
        navigate("/crm/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/crm", { state: { user: data }, replace: true });
      } catch (e) {
        if (e?.response?.status === 403) {
          navigate("/crm/login?denied=1", { replace: true });
        } else {
          navigate("/crm/login", { replace: true });
        }
      }
    };
    process();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[color:var(--hs-bg-0)] flex flex-col items-center justify-center gap-4">
      <img src="/logo.png" alt="Holdstill Records" className="h-12 w-auto opacity-80" />
      <div className="h-1 w-40 overflow-hidden rounded-full bg-white/10">
        <div className="h-full w-1/2 bg-[color:var(--hs-lime)] animate-pulse rounded-full" />
      </div>
      <p className="font-mono-ui text-xs tracking-[0.3em] uppercase text-white/50">Signing you in…</p>
    </div>
  );
}
